// Vendors
import $ from 'jquery';
import './vendors/bootstrap';
import './vendors/swiper';
import {initLazyLoad} from './vendors/lazyload';
import AOS from "aos";

// Layout
import {initOffcanvasToggling} from './layout/header';
import {setSliderWidth} from "./layout/infinite-slider";
import {setTableCellWidth} from "./layout/table";

// Components

// Invokes on document ready
$(function () {
    initLazyLoad?.();
    initOffcanvasToggling?.();
    setSliderWidth?.();
    setTableCellWidth?.();

    /**
     * Init animations
     */
    AOS.init({
        startEvent: 'load',
        disableMutationObserver: false,
        once: true,
        duration: 750,
        easing: 'ease-in-out'
    });
    AOS.refresh(true);
});